import enCommon from '@/locales/en/common.json';
import enNav from '@/locales/en/nav.json';
import enAuth from '@/locales/en/auth.json';
import enLanding from '@/locales/en/landing.json';
import enIris from '@/locales/en/iris.json';
import enDashboard from '@/locales/en/dashboard.json';
import enTrending from '@/locales/en/trending.json';
import enSettings from '@/locales/en/settings.json';
import enAlerts from '@/locales/en/alerts.json';
import esCommon from '@/locales/es/common.json';
import esNav from '@/locales/es/nav.json';
import esAuth from '@/locales/es/auth.json';
import esLanding from '@/locales/es/landing.json';
import esIris from '@/locales/es/iris.json';
import esDashboard from '@/locales/es/dashboard.json';
import esTrending from '@/locales/es/trending.json';
import esSettings from '@/locales/es/settings.json';
import esAlerts from '@/locales/es/alerts.json';
import zhCommon from '@/locales/zh/common.json';
import zhNav from '@/locales/zh/nav.json';
import zhAuth from '@/locales/zh/auth.json';
import zhLanding from '@/locales/zh/landing.json';
import zhIris from '@/locales/zh/iris.json';
import zhDashboard from '@/locales/zh/dashboard.json';
import zhTrending from '@/locales/zh/trending.json';
import zhSettings from '@/locales/zh/settings.json';
import zhAlerts from '@/locales/zh/alerts.json';
import viCommon from '@/locales/vi/common.json';
import viNav from '@/locales/vi/nav.json';
import viAuth from '@/locales/vi/auth.json';
import viLanding from '@/locales/vi/landing.json';
import viIris from '@/locales/vi/iris.json';
import viDashboard from '@/locales/vi/dashboard.json';
import viTrending from '@/locales/vi/trending.json';
import viSettings from '@/locales/vi/settings.json';
import viAlerts from '@/locales/vi/alerts.json';

export const resources = {
  en: {
    common: enCommon,
    nav: enNav,
    auth: enAuth,
    landing: enLanding,
    iris: enIris,
    dashboard: enDashboard,
    trending: enTrending,
    settings: enSettings,
    alerts: enAlerts
  },
  es: {
    common: esCommon,
    nav: esNav,
    auth: esAuth,
    landing: esLanding,
    iris: esIris,
    dashboard: esDashboard,
    trending: esTrending,
    settings: esSettings,
    alerts: esAlerts
  },
  zh: {
    common: zhCommon,
    nav: zhNav,
    auth: zhAuth,
    landing: zhLanding,
    iris: zhIris,
    dashboard: zhDashboard,
    trending: zhTrending,
    settings: zhSettings,
    alerts: zhAlerts
  },
  vi: {
    common: viCommon,
    nav: viNav,
    auth: viAuth,
    landing: viLanding,
    iris: viIris,
    dashboard: viDashboard,
    trending: viTrending,
    settings: viSettings,
    alerts: viAlerts
  }
} as const;

export type Resources = (typeof resources)['en'];

// English is the schema; this asserts every other locale exposes the same
// top-level namespaces and namespace shapes. Catches whole-namespace gaps —
// deep-leaf parity still needs lint/CI.
type LocaleNamespaceParity = {
  [L in Exclude<
    keyof typeof resources,
    'en'
  >]: (typeof resources)[L] extends Resources ? true : never;
};

const _localeNamespaceParity: LocaleNamespaceParity = {
  es: true,
  zh: true,
  vi: true
};
